module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "fi-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerItem.caption),
      expression: "innerItem.caption"
    }],
    staticClass: "caption",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.innerItem.caption)
    },
    on: {
      "focus": function($event) {
        return _vm.$emit('focused', _vm.innerItem, 'caption')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerItem, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "fa fi-multilangs",
    on: {
      "mouseup": _vm.onMultiLangs
    }
  })]), _c('select', {
    ref: "type",
    staticClass: "type",
    domProps: {
      "value": _vm.innerItem.type
    },
    on: {
      "change": function($event) {
        return _vm.typeChanged($event.target)
      },
      "focus": function($event) {
        return _vm.$emit('focused', _vm.innerItem, 'type')
      }
    }
  }, [_vm._l((_vm.source), function(item, idx) {
    return [_c('option', {
      key: idx,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])]
  })], 2), _c('input', {
    class: ['expr', _vm.itemReadonly && 'readonly'],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.innerItem.expression,
      "readOnly": _vm.itemReadonly
    },
    on: {
      "focus": function($event) {
        return _vm.$emit('focused', _vm.innerItem, 'expression')
      },
      "input": function($event) {
        return _vm.valueChanged($event.target)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fe03e78","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-ctrls/aggregateItem.vue
// module id = 85
// module chunks = 2